export default __webpack_public_path__ + "static/hero_ginfts-ff2b768b43fa99fb83ae7b904fa6de5f.svg";